import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PgFormField, PgFormLayout } from '../../../models/form.model';
import { DataService } from '../../../services/data.service';
import { LocalizationService } from '../../../services/localization.service';
import { NotificationsService } from '../../../services/notifications.service';
import { OptionMapsService } from '../../../services/option-maps.service';
import { AuthService } from '../../../services/auth.service';
import { SaveStatusService } from '../../../pg-ui-molecules/save-status.service';
import { EnvironmentService } from '../../../services/environment.service';
import { SingleFormComponent } from '../single-form-main';
import { PGUtilities } from '../../../utilities/pg-utilities';
import { EFDataService } from '../../../services/ef-data.service';

@Component({
    selector: 'app-forms-finder-environment',
    templateUrl: './forms-finder-environment.component.html',
    styleUrls: ['./forms-finder-environment.component.scss'],
    standalone: false
})
export class FormsFinderEnvironmentComponent extends SingleFormComponent {

    resourceId = 'FinderEnvironment';

    viewOptions:Array<{ value: string, text: string }> = []
    typeOptions:Array<{ value: string, text: string }> = []
    categoryOptions:Array<{ value: string, text: string, category?:string }> = []
    showcaseWithQROptions:Array<{ value: string, text: string, category?:string }> = []

    private _resourceByProductType = {
        'experience': 'Experience',
        'host': 'Host',
        'eatery': 'Eatery',
        'poi': 'Poi',
        'service': 'ExperienceSupplier',
        'itinerary': 'Itinerary',
        'article': 'Article',
        'event': 'Experience~Event',
    }

    constructor(protected dataService:DataService, protected authService:AuthService, protected localizationService:LocalizationService, protected router:Router, protected route:ActivatedRoute, protected notificationsService:NotificationsService, protected saveStatusService:SaveStatusService, protected optionMapsService:OptionMapsService, protected environmentService:EnvironmentService) {
        super(dataService, authService, localizationService, router, route, notificationsService, saveStatusService, optionMapsService, environmentService)

        for(let i in this._resourceByProductType) {
            this.typeOptions.push({ value: i, text: this.localizationService.translate('experience-finder.general.product-type-' + i) })
        }
        
        for(let _item of ['map','list','calendar']) {
            this.viewOptions.push({ value: _item, text: this.localizationService.translate('experience-finder.ef-main.nav-' + _item) })
        }
    }


    formLayout = new PgFormLayout([
        new PgFormField({ label: 'auto', type: 'string', name: 'pid', required: true }),
        new PgFormField({ label: 'auto', type: 'boolean', name: 'published', default: false }),
        new PgFormField({ label: 'auto', type: 'string', name: 'configuration', default: '-' }),
        new PgFormField({ label: 'auto', type: 'color', name: 'data_color' }),
        new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'data_logo' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_name' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_title' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'data_back' }),
        new PgFormField({ label: 'auto', type: 'boolean', name: 'data_backOnLogo' }),
        new PgFormField({ label: 'auto', type: 'file', fileType: 'images', name: 'data_footerLogo' }),
        new PgFormField({ label: 'auto', type: 'boolean', name: 'data_footerLarge' }),
        new PgFormField({ label: null, type: 'split', name: 'split_0' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'data_view', options: this.viewOptions }),
        new PgFormField({ label: 'auto', type: 'boolean', name: 'data_operatorsBanner' }),
        new PgFormField({ label: 'auto', type: 'boolean', name: 'data_showcase' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'data_showcaseWithQR', options: this.showcaseWithQROptions }),
        new PgFormField({ label: 'auto', type: 'json', name: 'data_filter' }),
        new PgFormField({ label: 'auto', type: 'json', name: 'data_showcaseContent' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'realm_id' }),
    ]);

    filterFields = [ 
        new PgFormField({ label: 'auto', type: 'list', name: 'type', options: this.typeOptions, order: true }),
        new PgFormField({ label: 'auto', type: 'select', name: 'category', options: this.categoryOptions, multi: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'tags' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'users', multi: true, resource: 'User' }),
    ]

    filterFieldsDisplay:{ [field:string]: any } = {
        'category': { oneLine: true }
    }

    showcaseContentFields = [ 
        new PgFormField({ label: 'auto', type: 'select', name: 'type', options: this.typeOptions }),
        new PgFormField({ label: 'auto', type: 'select', name: 'element', resource: null, resourceMode: 'public', readonly: true }),
    ]

    showcaseContentFieldsDisplay:{ [field:string]: any } = {
        'element': { oneLine: true }
    }
    
    availableLanguages:Array<string> = null;

    filterObject:any = null;
    showcaseContentList:any = null;

    showcaseContentObject = { type: null, element: null };

    protected afterInitializeForm() {
        return new Promise<void>((resolve, reject) => {
            this.availableLanguages = this.localizationService.availableApplicationLanguages;

            this.formLayout.getFieldByName('realm_id').default = this.authService.user.realm?.id;
            this.formLayout.getFieldByName('realm_id').visible = false;

            let _selectOptions:any = {}

            for(let _field of this.formLayout.fieldList) {
                let _cleanFieldName = _field.name.replace(/@.*$/, '')

                if(_field.label == 'auto') _field.label = 'RESOURCES.FinderEnvironment.fields.' + _cleanFieldName + '.label';
                if(_field.tooltip == 'auto') _field.tooltip = 'RESOURCES.FinderEnvironment.fields.' + _cleanFieldName + '.tooltip';
                if(_field.placeholder == 'auto') _field.placeholder = 'RESOURCES.FinderEnvironment.fields.' + _cleanFieldName + '.placeholder';

                if(_field.type == 'select') {
                    if(_field.options == null) {
                        _field.options = _selectOptions[_field.name]
                    }

                    this.formLayout.getFieldLayout(_field.name).display = { oneLine: true }
                }
                else if(_field.type == 'html' || _field.type == 'location') {
                    this.formLayout.getFieldLayout(_field.name).display = { fullWidth: true }
                }
            }

            for(let _field of this.filterFields) {
                if(_field.label == 'auto') _field.label = 'forms-finder-environment.filter-field-' + _field.name + '.label';
                if(_field.tooltip == 'auto') _field.tooltip = 'forms-finder-environment.filter-field-' + _field.name + '.tooltip';
                if(_field.placeholder == 'auto') _field.placeholder = 'forms-finder-environment.filter-field-' + _field.name + '.placeholder';
            }

            for(let _field of this.showcaseContentFields) {
                if(_field.label == 'auto') _field.label = 'forms-finder-environment.showcaseContent-field-' + _field.name + '.label';
                if(_field.tooltip == 'auto') _field.tooltip = 'forms-finder-environment.showcaseContent-field-' + _field.name + '.tooltip';
                if(_field.placeholder == 'auto') _field.placeholder = 'forms-finder-environment.showcaseContent-field-' + _field.name + '.placeholder';
            }

            this.formLayout.getFieldLayout('configuration').hidden = true;
            this.formLayout.getFieldLayout('data_filter').hidden = true;
            this.formLayout.getFieldLayout('data_showcaseContent').hidden = true;

            this.formLayout.getFieldLayout('data_showcaseWithQR').condition = '$form.data_showcase'

            this.formLayout.getFieldLayout('split_0').display = { invisible: true }

            this.dataService.getResourceData('TotemEnvironment', { limit: 5000 }, null, null, 'public').subscribe((data) => {
                this.showcaseWithQROptions.splice(0)

                this.showcaseWithQROptions.push({  
                    value: 'ExperienceFinder', 
                    text: this.localizationService.translate('forms-finder-environment.open-in-finder')
                })

                for(let _item of data) {
                    let _name = null;

                    try {
                        _name = JSON.parse(_item.data).name;
                    }
                    catch(ex) {}

                    this.showcaseWithQROptions.push({ 
                        value: 'TotemEnvironment_' + _item.pid, 
                        category: 'Cluer',
                        text: _name || _item.pid
                    })
                }

                resolve()
            })
        })
    }

    protected adaptLoadData(values:any) {
        values = JSON.parse(JSON.stringify(values));

        if(values.data != null) {
            let _data = PGUtilities.tryParseJSON(values.data);
            delete values.data;

            for(let i in _data) {
                values['data_' + i] = _data[i];
            }
        }

        return values;
    }

    protected async afterLoadData(values:any) {
        this.filterObject = PGUtilities.tryParseJSON(values.data_filter)
        if(this.filterObject == null) this.filterObject = {};

        this.showcaseContentList = PGUtilities.tryParseJSON(values.data_showcaseContent)
        if(this.showcaseContentList == null) this.showcaseContentList = [];

        this._refreshCategorySelect();
        this._checkShowcaseContentLabel();

        return values;
    }

    private _refreshCategorySelect() {
        this.categoryOptions.splice(0);
        
        let _typesList = PGUtilities.tryParseJSON(this.filterObject.type)

        if(_typesList != null) {
            let _categoriesIn:{ [id:string]: boolean } = {};

            for(let _type of _typesList) {
                let _resource = this._resourceByProductType[_type]

                let _field = 'category';
                if(_resource == 'Host' || _resource == 'Eatery') _field = 'type';

                let _optionList = this.optionMapsService.getResourceFieldOptionMap(_resource, _field)

                if(_optionList != null) {
                    for(let _option of _optionList) {
                        _option['category'] = this.localizationService.translate('RESOURCES.' + _resource + '.name')
                        this.categoryOptions.push(_option)

                        _categoriesIn[_option.value] = true;
                    }
                }
            }

            let _categories:Array<string> = PGUtilities.tryParseJSON(this.filterObject.category)
            if(_categories == null) _categories = [];

            for(let i = _categories.length - 1; i >= 0; i--) {
                if(!_categoriesIn[_categories[i]]) {
                    _categories.splice(i, 1)
                }
            }

            if(_categories.length == 0) {
                this.filterObject.category = null
            }
            else {
                this.filterObject.category = JSON.stringify(_categories)
            }
        }
        else {
            this.filterObject.category = null;
        }

        for(let _field of this.filterFields) {
            if(_field.name == 'category') {
                _field.readonly = this.filterObject.type == null
            }
        }
    }

    onFilterValueChange(field:string) {
        if(field == 'type') {
            this._refreshCategorySelect()
        }

        let _data = JSON.stringify(this.filterObject)

        this.formLayout.setData({ data_filter: _data })
        this.onValueChange({ data_filter: _data })
    }

    onShowcaseContentValueChange() {
        this.showcaseContentFields[1].resource = this._resourceByProductType[this.showcaseContentObject.type]
        this.showcaseContentFields[1].readonly = (this.showcaseContentFields[1].resource == null)
    }

    protected adaptSaveData(values:any) {
        values = JSON.parse(JSON.stringify(values));

        let _data:any = {};

        let _dataFields = [];

        for(let i in values) {
            if(/^data_/.test(i)) {
                _dataFields.push(i)
            }
        }

        for(let _field of _dataFields) {
            _data[_field.replace(/^data_/, '')] = values[_field];
            delete values[_field];
        }

        values.data = JSON.stringify(_data);

        return values;
    }

    canShowcaseContentAdd() {
        if(this.showcaseContentObject.type == null || this.showcaseContentObject.element == null) {
            return false;
        }
        else {
            for(let _item of this.showcaseContentList) {
                if(_item.resource == this.showcaseContentObject.type && _item.element == this.showcaseContentObject.element) return false;
            }

            return true;
        }
    }

    doShowcaseContentAdd() {
        this.showcaseContentList.push(this.showcaseContentObject)
        this.showcaseContentObject = { type: null, element: null };
        this.onShowcaseContentValueChange()

        this._checkShowcaseContentLabel()

        let _data = JSON.stringify(this.showcaseContentList);

        this.formLayout.setData({ data_showcaseContent: _data })
        this.onValueChange({ data_showcaseContent: _data })
    }

    doShowcaseContentRemove(item:any) {
        let _index = this.showcaseContentList.indexOf(item)
        this.showcaseContentList.splice(_index, 1)

        let _data = JSON.stringify(this.showcaseContentList);

        this.formLayout.setData({ data_showcaseContent: _data })
        this.onValueChange({ data_showcaseContent: _data })
    }

    private _checkShowcaseContentLabel() {
        for(let _item of this.showcaseContentList) {
            if(_item.label == null) {
                this.dataService.getElementData(_item.type, _item.element).subscribe((data) => {
                    _item.label = this.localizationService.translate('experience-finder.general.product-type-' + _item.type) + ' - ' + (data.name || data.title || data.id);
                    this._checkShowcaseContentLabel();
                })
                break;
            }
        }
    }
}

